KMVP.preview = {

    /**
     * Writes the text defined in ACC.messages.previewModeBackgroundText
     * in the background of the page.
     **/
    showPreviewInformation: function () {
        var canvas = document.createElement("canvas");
        canvas.setAttribute('height', 100);
        canvas.setAttribute('width', 200);
        var context = canvas.getContext('2d');
        context.fillStyle = 'rgba(0,0,0,0.1)';
        context.font = '24px sans-serif';
        context.fillText(ACC.messages.previewModeBackgroundText, 50, 50);
        $('body').css({'background-image': "url(" + canvas.toDataURL("image/png") + ")"});
    },

    /**
     * Shows a banner on top of the page.
     **/
    showPreviewBanner: function () {
        $('.preview-mode-banner').slideDown()
    },

    /**
     * Binds the form to leave the preview mode as an ajax form.
     **/
    bindPreviewModeExitForm: function () {
        $('.preview-mode-exit-form').ajaxForm({
            complete: function () {
                $('.preview-mode-banner').slideUp()
                window.close();
                // We try an additional page reload, in case the close fails,
                // because the current window was not opened by a script.
                // See: https://www.w3.org/TR/html51/browsers.html#script-closable
                window.location.reload();
            }

        });
    }

};

$(document).ready(function () {
    if (ACC.previewMode) {
        KMVP.preview.showPreviewInformation();
        KMVP.preview.showPreviewBanner();
        KMVP.preview.bindPreviewModeExitForm();
    }
});
